module.exports = __webpack_public_path__ + "img/wordpress.5c09a894.svg";